import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { pathOr } from 'ramda';

import { ClassProp } from 'helpers/types';
import { useGetMerchantInfo } from 'helpers/useGetMerchantInfo';

import BrandAssets from './scenes/BrandAssets';
import BrandAssetApprovalT3 from './scenes/BrandAssetApprovalT3';
import BrandAssetManagement from './scenes/BrandAssetManagement';

import { GET_MERCHANT } from './MerchantBrandAssets.queries';
import { Merchant } from './MerchantBrandAssets.helpers';
import styles from './MerchantBrandAssets.styles';

type Styles = ClassProp<ReturnType<typeof styles>>;

type Props = {
  classes: Styles;
};

const brandAssets = (merchant: Merchant) => <BrandAssets merchant={merchant} />;

const brandAssetApprovalT3 = (merchant: Merchant) => (
  <BrandAssetApprovalT3 merchant={merchant} />
);

const brandAssetManagement = (merchant: Merchant) => (
  <BrandAssetManagement merchant={merchant} />
);

const MerchantBrandAssets: FunctionComponent<Props> = ({ classes }) => {
  const match = useRouteMatch();
  const { loading, merchantDetails } = useGetMerchantInfo(match, GET_MERCHANT);

  if (loading) return null;

  const merchant = pathOr({}, ['merchantList', 'result', 0], merchantDetails);

  const renderBrandAssets = () => brandAssets(merchant);
  const renderBrandAssetApprovalT3 = () => brandAssetApprovalT3(merchant);
  const renderBrandAssetManagement = () => brandAssetManagement(merchant);

  return (
    <Switch>
      <Route
        path={`${match.path}/approval`}
        component={renderBrandAssetApprovalT3}
        exact
      />
      <Route
        path={`${match.path}/asset-management`}
        component={renderBrandAssetManagement}
      />
      <Route path={`${match.path}`} component={renderBrandAssets} exact />
    </Switch>
  );
};
export default withStyles(styles)(MerchantBrandAssets);
